import Avatar from '@mui/material/Avatar';
import { tutorAvatarInitials } from '../utils/tutorAvatarInitials';

type RoomBookingUserAvatarProps = {
  userProfileImageUrl?: string | null;
  /** Used for initials when the image URL is missing. */
  displayName?: string;
  size?: number;
};

export default function RoomBookingUserAvatar({
  userProfileImageUrl,
  displayName = '',
  size = 48,
}: RoomBookingUserAvatarProps) {
  return (
    <Avatar
      src={userProfileImageUrl?.trim() || undefined}
      alt=""
      variant="rounded"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        bgcolor: '#4AA7C6',
        color: '#ffffff',
        fontSize: size >= 48 ? '1.125rem' : size >= 32 ? '0.875rem' : '0.7rem',
        fontWeight: 600,
      }}
    >
      {tutorAvatarInitials(displayName)}
    </Avatar>
  );
}
